import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Product, MyCartList, DeliveryWithChargeViewModel, ValidateCheckoutVM } from '../model/types'
import { Storage } from '@ionic/storage';
import { LoadingController } from 'ionic-angular';

import { AppSharedService } from '../service/app_shared';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class ProductService {

  // declare class level variable
  MyCarItemList: MyCartList[];
  MyCartItemVendorList: number[];
  TotalCartLength: number;
  CartTotalAmount: number;
  BannerList: string[];
  cartItemsList: DeliveryWithChargeViewModel[];
  totalDeliveryCharge: number;
  deliveryInformation: ValidateCheckoutVM;

  selectedProduct: Product = {
    ProductId: 0,
    Notes: "",
    ProductLongDescription: "",
    ProductName: "",
    ProductShortDescription: "",
    ProductMappingList: [],
    BrandName: "",
    FoodType: "",
    Picture: "",
    ProductType: "",
    SizeList: [],
    VendorName: "",
    DescriptionList: [],
    PictureList: [],
    VendorId: 0
  };
  productList: Product[];
  constructor(public http: Http
    , public storage: Storage
    , public loadingCtrl: LoadingController
    , public appSharedService: AppSharedService
    , private httpc: HttpClient
  ) {

    // initialize class default variable
    let defCartItem: MyCartList = {
      Picture1: "",
      ProductId: 0,
      ProductMappingId: 0,
      ProductUnitId: 0,
      ProductMinQuantity: 0,
      ProductName: "",
      ProductPrice: 0,
      ProductQuantity: 0,
      ProductQuantityDescription: "",
      ProductTotalAmount: 0,
      VendorId: 0,
      VendorName: ""
    }
    this.MyCarItemList = [];
    this.MyCarItemList.push(defCartItem);
    this.TotalCartLength = 0;
    this.CartTotalAmount = 0;
    this.MyCartItemVendorList = [];
    this.BannerList = [];
    this.deliveryInformation = {
      addressList: [],
      deliveryInfoDetails: [],
      walletAmount: 0
    };
    this.totalDeliveryCharge = 0;
    this.cartItemsList = [];
  }
  /*
  postEmployee(emp : Product){
    var body = JSON.stringify(emp);
    var headerOptions = new Headers({'Content-Type':'application/json'});
    var requestOptions = new RequestOptions({method : RequestMethod.Post,headers : headerOptions});
    return this.http.post('http://localhost:28750/api/Employee',body,requestOptions).map(x => x.json());
  }
*/
  /*
    putEmployee(id, emp) {
      var body = JSON.stringify(emp);
      var headerOptions = new Headers({ 'Content-Type': 'application/json' });
      var requestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headerOptions });
      return this.http.put('http://localhost:28750/api/Employee/' + id,
        body,
        requestOptions).map(res => res.json());
    }
    */

  // get product list from storage
  utility_GetProductListFromCart() {
    this.storage.get("bz_cart_02").then((data) => {
      // debugger;
      if (data) {
        data.forEach(element => {
          if (element.ProductMinQuantity > 0) {
            element.ProductUnitId = parseInt(element.ProductUnitId);
            element.ProductQuantity = parseInt(element.ProductQuantity);
            let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitAmountForAppv2 + element.ProductId + '/unitamount/' + element.ProductUnitId + '/' + element.ProductQuantity + '/' + element.VendorId);

            // get product
            this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
              if (res.status == 200) {
                if (res.body != undefined && res.body != null) {
                  element.ProductTotalAmount = res.body;
                  this.MyCarItemList = data;
                  this.TotalCartLength = (data != undefined && data != null ? data.length : 0);
                  this.CartTotalAmount = this.utility_calculateCartAmount(data);
                  this.calculateVendor();
                  this.createDeliveryItemChart();
                }
              }
            });
          } else {
            this.MyCarItemList = data;
            this.TotalCartLength = (data != undefined && data != null ? data.length : 0);
            this.CartTotalAmount = this.utility_calculateCartAmount(data);
            this.calculateVendor();
            this.createDeliveryItemChart();
          }
        });
      } else {
        this.MyCarItemList = data;
        this.TotalCartLength = (data != undefined && data != null ? data.length : 0);
        this.CartTotalAmount = this.utility_calculateCartAmount(data);
        this.calculateVendor();
        this.createDeliveryItemChart();
      }
    });
  }

  // calculate total amount of cart list
  utility_calculateCartAmount(data: MyCartList[]): number {

    var Amount = 0;

    if (data != undefined && data != null && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        Amount = Amount + data[i].ProductTotalAmount;
      }
      if (data != null && data != undefined && data.length > 0) {
        this.MyCartItemVendorList = data.map(dataitem => dataitem.VendorId).filter((x, i, a) => x && a.indexOf(x) === i);
      }
    }

    return Amount;
  }

  calculateVendor() {
    if (this.MyCarItemList != undefined && this.MyCarItemList != null && this.MyCarItemList.length > 0) {
      this.MyCartItemVendorList = this.MyCarItemList.map(data => data.VendorId).filter((x, i, a) => x && a.indexOf(x) === i);
    }
  }

  createDeliveryItemChart() {
    this.cartItemsList = [];
    this.totalDeliveryCharge = 0;
    this.calculateVendor();

    if (this.MyCarItemList != undefined && this.MyCarItemList != null && this.MyCarItemList.length > 0) {

      this.MyCartItemVendorList.forEach((keys) => {

        let vendor = this.deliveryInformation
          .deliveryInfoDetails.find(function (element) {
            return element.VendorId == keys;
          });

        let vendorInfo: DeliveryWithChargeViewModel = {
          DeliveryChargeAmount: 0,
          DeliveryInfo: "",
          MyCarItemList: [],
          TotalAmount: 0,
          VendorId: 0,
          VendorName: ""
        };
        vendorInfo.VendorId = keys;

        let cartinf: MyCartList[] = [];
        let curtotalAmount = 0;
        this.MyCarItemList.forEach((item) => {
          if (item.VendorId == keys) {
            cartinf.push(item);
            curtotalAmount = curtotalAmount + item.ProductTotalAmount;
          }
        });
        vendorInfo.TotalAmount = curtotalAmount;
        vendorInfo.MyCarItemList = cartinf;
        vendorInfo.DeliveryChargeAmount = 0;

        if (vendor != undefined && vendor != null) {
          vendorInfo.VendorName = vendor.VendorName;
          vendorInfo.DeliveryInfo = vendor.DeliveryInfo;


          //calculate delivery charge
          let delChargeItem = vendor.deliveryChargeList.find(function (element) {
            return element.MinOrderAmount <= curtotalAmount && element.MaxOrderAmount >= curtotalAmount
          });

          if (delChargeItem != null) {
            vendorInfo.DeliveryChargeAmount = delChargeItem.DeliveryAmount;
          }

        }

        this.cartItemsList.push(vendorInfo);
      });
      for (var i in this.cartItemsList) { this.totalDeliveryCharge += this.cartItemsList[i].DeliveryChargeAmount; }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/service/product_service.ts